export const ORDER_STATUS_FILTER_OPTIONS = [
  {
    value: '',
    label: 'orderStatus.all',
  },
  {
    value: 'invoiced',
    label: 'orderStatus.invoiced',
  },
  {
    value: 'open',
    label: 'orderStatus.open',
  },
  {
    value: 'in_progress',
    label: 'orderStatus.inProgress',
  },
  {
    value: 'delivered',
    label: 'orderStatus.delivered',
  },
  {
    value: 'cancelled',
    label: 'orderStatus.cancelled',
  },
]
